import { createEffect } from 'effector';
import {
    traderPayinTraderServiceBalance,
    traderPayinTraderServiceGetMe,
    traderPayinTraderServiceRegister,
} from '~/generated/payinBackend/trader';

export const getBalanceFx = createEffect(traderPayinTraderServiceBalance);
export const getMeTraderFx = createEffect(async () => {
    return await traderPayinTraderServiceGetMe({
        context: {
            skipErrorNotification: true,
        },
    });
});
export const verifyTraderFx = createEffect(traderPayinTraderServiceRegister);
